import EvaluationPerformWizard from '../../../components/Evaluation/EvaluationPerformWizard';

const PerformEvaluation = () => {
    return (
        <>
            <EvaluationPerformWizard />
        </>
    );
};

export default PerformEvaluation;
